import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { LoginService } from "../login.service";
import { AllDayEventService } from "../all-day-event.service";

@Component({
    selector: "app-all-day-event",
    templateUrl: "./all-day-event.component.html",
    styleUrls: ["./all-day-event.component.scss"],
    standalone: false
})
export class AllDayEventComponent implements OnInit {
  @Output() closed = new EventEmitter<boolean>();
  @Input("event") event;
  @Input("selectedResourceId") selectedResourceId: string = "";
  @Input("isMultiSelect") isMultiSelect: boolean = false;
  allDayEventForm: UntypedFormGroup;
  startOptionalsHours = [];
  showDeleteAlert = false;
  error;
  formattedDuration = { days: 0, hours: 0, minutes: 0 };
  constructor(
    private fb: UntypedFormBuilder,
    public ls: LoginService,
    public allDayEventService: AllDayEventService
  ) {}

  ngOnInit(): void {
    this.resetEventForm();
    this.allDayEventForm.get("duration").valueChanges.subscribe((value) => {
      this.formattedDuration = this.calculateDuration(value);
    });
    this.loadEventForm();
    this.subscribeToFormChanges();
  }

  resetEventForm() {
    this.allDayEventForm = this.fb.group({
      AutoIndex: [""],
      eventStartDate: [""],
      duration: [""],
      comment: [null],
      UID: [[]],
      eventEndDate: [""],
      RID: [[]],
    });
  }

  subscribeToFormChanges() {
    // Track changes on both start and end dates or hours
    const startDateControl = this.allDayEventForm.get("eventStartDate");
    const endDateControl = this.allDayEventForm.get("eventEndDate");

    startDateControl.valueChanges.subscribe(() => this.updateDuration());
    endDateControl.valueChanges.subscribe(() => this.updateDuration());
  }

  updateDuration() {
    const startValue = this.allDayEventForm.get("eventStartDate").value;
    const endValue = this.allDayEventForm.get("eventEndDate").value;

    if (startValue && endValue) {
      const startDate = new Date(startValue);
      const endDate = new Date(endValue);

      // Calculate duration in minutes
      const durationInMinutes = (endDate.getTime() - startDate.getTime()) / 1000 / 60;
      this.allDayEventForm.get("duration").setValue(durationInMinutes);
      this.formattedDuration = this.calculateDuration(durationInMinutes);
    }
  }

  loadEventForm() {
    this.allDayEventForm.get("duration").setValue(this.allDayEventService.duration);
    this.allDayEventForm.get("eventStartDate").setValue(this.allDayEventService.startDate);
    this.allDayEventForm.get("eventEndDate").setValue(this.allDayEventService.endDate);

    if (this.isMultiSelect) {
      this.ls.premissions?.ApptsByRoom
        ? this.allDayEventForm.get("RID").setValue([this.selectedResourceId])
        : this.allDayEventForm.get("UID").setValue([this.selectedResourceId]);
    } else {
      this.ls.premissions?.ApptsByRoom
        ? this.allDayEventForm.get("RID").setValue([this.ls.room])
        : this.allDayEventForm.get("UID").setValue([this.ls.doctor]);
    }

    if (this.event) {
      this.allDayEventForm.get("AutoIndex").setValue(this.allDayEventService.AutoIndex);
      this.allDayEventForm.get("UID").setValue([this.event.DocUID]);
      this.allDayEventForm.get("comment").setValue(this.event.comment);
      this.allDayEventForm.get("RID").setValue([this.event.RID]);
    }
  }

  async deleteEvent() {
    try {
      const result = await this.allDayEventService.delete();
      if (result) {
        this.closeEventModal();
      }
    } catch (error) {
      console.error("Error during the deletion process:", error);
    }
  }

  async updateEvent() {
    try {
      const result = await this.allDayEventService.updateEvent(this.allDayEventForm.value);
      if (result["status"] == "ok") {
        this.error = false;
        this.closeEventModal();
      }
    } catch (error) {
      console.error("Error during the update event:", error);
      this.error = true;
    }
  }

  closeEventModal() {
    this.closed.emit();
  }

  saveEvent() {
    this.allDayEventService.addAllDayEvent(this.allDayEventForm.value).subscribe((data) => {
      this.closeEventModal();
    });
  }

  calculateDuration(durationInMinutes: number) {
    const minutesInADay = 60 * 24;
    const minutesInAnHour = 60;

    const days = Math.floor(durationInMinutes / minutesInADay);
    durationInMinutes -= days * minutesInADay;

    const hours = Math.floor(durationInMinutes / minutesInAnHour);
    durationInMinutes -= hours * minutesInAnHour;

    const minutes = durationInMinutes;

    return { days, hours, minutes };
  }

  ngOnDestroy(): void {}
}
